module.exports = __webpack_public_path__ + "img/logo.06171d9b.jpeg";